(function () {
  var CART_KEY = 'ravzelo_pet_proto_cart_v1';

  function readCart() {
    try {
      var raw = localStorage.getItem(CART_KEY);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function writeCart(items) {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    syncCartCount();
    document.dispatchEvent(new CustomEvent('rv-pet-cart-updated', { detail: { items: items } }));
  }

  function cartCount(items) {
    return (items || readCart()).reduce(function (sum, item) {
      return sum + (Number(item.qty) || 0);
    }, 0);
  }

  function cartTotal(items) {
    return (items || readCart()).reduce(function (sum, item) {
      return sum + (Number(item.price) || 0) * (Number(item.qty) || 0);
    }, 0);
  }

  function money(value) {
    return '$' + Number(value).toFixed(2);
  }

  function syncCartCount() {
    var count = cartCount();
    document.querySelectorAll('[data-rv-pet-cart-count]').forEach(function (element) {
      element.textContent = String(count);
    });
  }

  function addToCart(payload) {
    var items = readCart();
    var existing = items.find(function (item) {
      return item.handle === payload.handle;
    });
    var quantity = Math.max(1, Number(payload.qty) || 1);
    if (existing) {
      existing.qty = (Number(existing.qty) || 0) + quantity;
    } else {
      items.push({
        handle: payload.handle,
        title: payload.title,
        price: Number(payload.price) || 0,
        qty: quantity
      });
    }
    writeCart(items);
    return items;
  }

  function setQty(handle, quantity) {
    var items = readCart().map(function (item) {
      if (item.handle !== handle) return item;
      return Object.assign({}, item, { qty: Math.max(0, Number(quantity) || 0) });
    }).filter(function (item) {
      return item.qty > 0;
    });
    writeCart(items);
    return items;
  }

  function removeItem(handle) {
    writeCart(readCart().filter(function (item) {
      return item.handle !== handle;
    }));
  }

  function initChrome(root) {
    var header = root.querySelector('[data-rv-pet-header]');
    var mobileMenu = root.querySelector('[data-rv-pet-menu]');
    var mobileOpen = root.querySelector('[data-rv-pet-menu-open]');
    var mobilePanel = root.querySelector('.rv-pet__mobile-panel');
    var mobileClose = mobileMenu && mobileMenu.querySelector('.rv-pet__mobile-head [data-rv-pet-menu-close]');
    var overHero = header && header.classList.contains('rv-pet__header--over-hero');
    var lastFocused = null;

    var getScrollTop = function () {
      return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    };
    var syncHeader = function () {
      if (!header || !overHero) return;
      header.classList.toggle('is-solid', getScrollTop() > 8);
    };
    var closeMenu = function () {
      var wasOpen = mobileMenu && mobileMenu.classList.contains('is-open');
      mobileMenu && mobileMenu.classList.remove('is-open');
      mobileMenu && mobileMenu.setAttribute('aria-hidden', 'true');
      mobileOpen && mobileOpen.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('rv-pet-menu-open');
      if (wasOpen && lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    };
    var openMenu = function () {
      lastFocused = document.activeElement;
      mobileMenu && mobileMenu.classList.add('is-open');
      mobileMenu && mobileMenu.setAttribute('aria-hidden', 'false');
      mobileOpen && mobileOpen.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('rv-pet-menu-open');
      window.setTimeout(function () {
        if (mobileClose) {
          mobileClose.focus();
        } else if (mobilePanel) {
          mobilePanel.focus();
        }
      }, 0);
    };

    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
    window.addEventListener('pageshow', syncHeader);
    mobileOpen && mobileOpen.addEventListener('click', openMenu);
    mobileMenu && mobileMenu.addEventListener('click', function (event) {
      if (event.target.closest('[data-rv-pet-menu-close]') || event.target.closest('nav a')) {
        closeMenu();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (!mobileMenu || !mobileMenu.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu();
        return;
      }
      if (event.key !== 'Tab' || !mobilePanel) return;
      var focusable = Array.from(
        mobilePanel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initMagneticButtons(root) {
    if (
      prefersReducedMotion() ||
      !window.matchMedia ||
      !window.matchMedia('(hover: hover) and (pointer: fine)').matches
    ) {
      return;
    }

    root.querySelectorAll('[data-rv-motion-magnetic]').forEach(function (button) {
      if (button.hasAttribute('data-rv-motion-magnetic-ready')) return;
      button.setAttribute('data-rv-motion-magnetic-ready', '');

      button.addEventListener('pointermove', function (event) {
        var rect = button.getBoundingClientRect();
        var relativeX = event.clientX - rect.left;
        var relativeY = event.clientY - rect.top;
        var offsetX = Math.max(-6, Math.min(6, (relativeX - rect.width / 2) * .075));
        var offsetY = Math.max(-5, Math.min(5, (relativeY - rect.height / 2) * .1));

        button.style.setProperty('--rv-motion-x', offsetX.toFixed(2) + 'px');
        button.style.setProperty('--rv-motion-y', offsetY.toFixed(2) + 'px');
        button.style.setProperty('--rv-motion-origin-x', ((relativeX / rect.width) * 100).toFixed(1) + '%');
        button.style.setProperty('--rv-motion-origin-y', ((relativeY / rect.height) * 100).toFixed(1) + '%');
      });

      button.addEventListener('pointerleave', function () {
        button.style.setProperty('--rv-motion-x', '0px');
        button.style.setProperty('--rv-motion-y', '0px');
        button.style.setProperty('--rv-motion-origin-x', '50%');
        button.style.setProperty('--rv-motion-origin-y', '50%');
      });
    });
  }

  function initJourneyMotion(root) {
    root.querySelectorAll('[data-rv-journey-motion]').forEach(function (board) {
      if (board.hasAttribute('data-rv-journey-motion-ready')) return;
      board.setAttribute('data-rv-journey-motion-ready', '');

      if (prefersReducedMotion()) {
        board.classList.add('is-journey-revealed');
        return;
      }

      var revealBoard = function () {
        board.classList.add('is-journey-revealed');
      };

      if (!('IntersectionObserver' in window)) {
        revealBoard();
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealBoard();
          observer.unobserve(board);
        });
      }, {
        threshold: .32,
        rootMargin: '0px 0px -8% 0px'
      });

      observer.observe(board);
    });
  }

  function initMotion(root) {
    initMagneticButtons(root);
    initJourneyMotion(root);

    var reveals = root.querySelectorAll('[data-rv-motion-reveal]');
    if (!reveals.length) return;

    root.classList.add('rv-motion-ready');
    if (prefersReducedMotion()) {
      reveals.forEach(function (element) {
        element.classList.add('is-revealed');
      });
      return;
    }

    var pendingReveals = Array.from(reveals);
    var revealFrame = null;

    function revealVisibleHeadings() {
      revealFrame = null;
      var revealLine = window.innerHeight * .92;
      pendingReveals = pendingReveals.filter(function (element) {
        var rect = element.getBoundingClientRect();
        var isVisible = rect.top < revealLine && rect.bottom > 0;
        if (isVisible) {
          element.classList.add('is-revealed');
          return false;
        }
        return true;
      });

      if (!pendingReveals.length) {
        window.removeEventListener('scroll', requestRevealCheck);
        window.removeEventListener('resize', requestRevealCheck);
      }
    }

    function requestRevealCheck() {
      if (revealFrame !== null) return;
      revealFrame = window.requestAnimationFrame(revealVisibleHeadings);
    }

    window.addEventListener('scroll', requestRevealCheck, { passive: true });
    window.addEventListener('resize', requestRevealCheck);
    requestRevealCheck();
  }

  function resetAddToCartMotion(button) {
    if (!button) return;
    button.classList.remove('is-loading', 'is-verified');
    button.removeAttribute('aria-busy');
  }

  function showAddToCartVerification(button) {
    if (!button) return;
    resetAddToCartMotion(button);
    void button.offsetWidth;
    button.classList.add('is-verified');
    window.setTimeout(function () {
      resetAddToCartMotion(button);
    }, prefersReducedMotion() ? 700 : 2200);
  }

  function getShopifyRouteRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function initLiveAddToCartMotion(root) {
    root.querySelectorAll('.rv-pet__product-form').forEach(function (form) {
      if (form.hasAttribute('data-rv-pet-atc-ready')) return;
      var button = form.querySelector('[data-rv-pet-atc-motion]');
      var status = root.querySelector('[data-rv-pet-atc-status]');
      if (!button || button.disabled) return;

      form.setAttribute('data-rv-pet-atc-ready', '');
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (button.classList.contains('is-loading')) return;

        if (status) {
          status.textContent = '';
          status.classList.remove('is-error');
        }

        button.classList.remove('is-verified');
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;

        var routeRoot = getShopifyRouteRoot();

        try {
          var response = await fetch(routeRoot + 'cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin',
            body: new FormData(form)
          });
          var result = await response.json().catch(function () {
            return {};
          });

          if (!response.ok) {
            throw new Error(result.description || result.message || 'This item could not be added.');
          }

          try {
            var cartResponse = await fetch(routeRoot + 'cart.js', {
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
              cache: 'no-store'
            });
            if (cartResponse.ok) {
              var cart = await cartResponse.json();
              document.querySelectorAll('[data-rv-pet-cart-count]').forEach(function (element) {
                element.textContent = String(cart.item_count);
              });
            }
          } catch (cartError) {
            // The add succeeded; a delayed cart-count refresh should not turn it into an error.
          }

          showAddToCartVerification(button);
          if (status) {
            status.textContent = 'Added to your cart.';
            window.setTimeout(function () {
              status.textContent = '';
            }, 4000);
          }

          try {
            var petCartDrawer = window.RavzeloCartDrawers && window.RavzeloCartDrawers.pet;
            if (petCartDrawer && typeof petCartDrawer.refreshAndOpen === 'function') {
              await petCartDrawer.refreshAndOpen();
            }
          } catch (drawerError) {
            // The add succeeded; keep the confirmation visible if the drawer refresh is unavailable.
          }
        } catch (error) {
          resetAddToCartMotion(button);
          if (status) {
            status.textContent = error && error.message
              ? error.message
              : 'This item could not be added. Please try again.';
            status.classList.add('is-error');
          }
        } finally {
          button.disabled = false;
        }
      });
    });
  }

  function initFilters(root) {
    var buttons = root.querySelectorAll('[data-rv-pet-filter]');
    var cards = root.querySelectorAll('[data-category]');
    var countElement = root.querySelector('[data-rv-pet-shop-count]');
    var countNoun = root.querySelector('[data-rv-pet-shop-count-noun]');
    var filterEmpty = root.querySelector('[data-rv-pet-filter-empty]');
    var detailParents = {
      'out-about': 'outdoor-group',
      'walk-group': 'outdoor-group',
      'pet-leashes': 'outdoor-group',
      'pet-harnesses': 'outdoor-group',
      'pet-collars': 'outdoor-group',
      'travel-bowls': 'outdoor-group',
      'travel-water-bottles': 'outdoor-group',
      'travel-feeders': 'outdoor-group',
      'car-ride': 'car-travel-group',
      'ride-group': 'car-travel-group',
      'seat-covers': 'car-travel-group',
      'car-hammocks': 'car-travel-group',
      'cargo-liners': 'car-travel-group',
      'safety-tethers': 'car-travel-group',
      'carry-group': 'travel-essentials-group',
      'soft-carriers': 'travel-essentials-group',
      'pet-backpacks': 'travel-essentials-group',
      'pet-strollers': 'travel-essentials-group',
      'travel-crates': 'travel-essentials-group',
      'stay-away': 'travel-essentials-group',
      'rest-group': 'travel-essentials-group',
      'travel-mats': 'travel-essentials-group',
      'travel-beds': 'travel-essentials-group',
      'travel-blankets': 'travel-essentials-group',
      'eat-group': 'outdoor-group'
    };
    if (!buttons.length) return;

    function categoriesFor(card) {
      return (card.getAttribute('data-category') || '').split(/\s+/).filter(Boolean);
    }

    function apply(filter) {
      var visible = 0;
      cards.forEach(function (card) {
        var match = filter === 'all' || categoriesFor(card).indexOf(filter) !== -1;
        card.hidden = !match;
        if (match) visible += 1;
      });
      buttons.forEach(function (button) {
        var buttonFilter = button.getAttribute('data-rv-pet-filter');
        var isActive = buttonFilter === filter || buttonFilter === detailParents[filter];
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });
      if (countElement) countElement.textContent = String(visible);
      if (countNoun) countNoun.textContent = visible === 1 ? 'piece' : 'pieces';
      if (filterEmpty) filterEmpty.hidden = filter === 'all' || visible > 0;
    }

    function filterFromHash() {
      var hashFilter = decodeURIComponent(window.location.hash.replace(/^#/, ''));
      var hasMatchingCard = Array.from(cards).some(function (card) {
        return categoriesFor(card).indexOf(hashFilter) !== -1;
      });
      if (hasMatchingCard) return hashFilter;
      return detailParents[hashFilter] || 'all';
    }

    buttons.forEach(function (button) {
      var filter = button.getAttribute('data-rv-pet-filter') || 'all';
      if (filter !== 'all') {
        var hasMatch = Array.from(cards).some(function (card) {
          return categoriesFor(card).indexOf(filter) !== -1;
        });
        button.hidden = !hasMatch;
      }
      button.addEventListener('click', function () {
        apply(filter);
        if (window.history && window.history.replaceState) {
          var nextUrl = window.location.pathname + window.location.search + (filter === 'all' ? '' : '#' + filter);
          window.history.replaceState(null, '', nextUrl);
        }
      });
    });
    window.addEventListener('hashchange', function () {
      apply(filterFromHash());
    });
    apply(filterFromHash());
  }

  function initLocalSort(root) {
    var select = root.querySelector('[data-rv-pet-local-sort]');
    var grid = root.querySelector('.rv-pet__shop-grid');
    if (!select || !grid) return;
    var cards = Array.from(grid.querySelectorAll('.rv-pet__shop-card'));
    cards.forEach(function (card, index) {
      card.dataset.originalOrder = String(index);
    });

    select.addEventListener('change', function () {
      var sortValue = select.value;
      var sorted = cards.slice().sort(function (a, b) {
        if (sortValue === 'price-ascending' || sortValue === 'price-descending') {
          var priceDifference = Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
          return sortValue === 'price-descending' ? -priceDifference : priceDifference;
        }
        if (sortValue === 'title-ascending') {
          return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        }
        return Number(a.dataset.originalOrder || 0) - Number(b.dataset.originalOrder || 0);
      });
      sorted.forEach(function (card) {
        grid.appendChild(card);
      });
    });
  }

  function initQuantityControls(root) {
    root.querySelectorAll('.rv-pet__qty').forEach(function (control) {
      var quantityInput = control.querySelector('[data-rv-pet-qty]');
      var minus = control.querySelector('[data-rv-pet-qty-minus]');
      var plus = control.querySelector('[data-rv-pet-qty-plus]');
      if (!quantityInput) return;
      minus && minus.addEventListener('click', function () {
        quantityInput.value = String(Math.max(1, (Number(quantityInput.value) || 1) - 1));
      });
      plus && plus.addEventListener('click', function () {
        quantityInput.value = String(Math.max(1, (Number(quantityInput.value) || 1) + 1));
      });
    });
  }

  function initAddToCart(root) {
    var form = root.querySelector('[data-rv-pet-add-form]');
    if (!form) return;
    var toast = root.querySelector('[data-rv-pet-toast]');
    var quantityInput = form.querySelector('[data-rv-pet-qty]');
    var submitButton = form.querySelector('[data-rv-pet-atc-motion]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      addToCart({
        handle: form.getAttribute('data-handle'),
        title: form.getAttribute('data-title'),
        price: form.getAttribute('data-price'),
        qty: quantityInput ? quantityInput.value : 1
      });
      showAddToCartVerification(submitButton);
      if (toast) {
        toast.textContent = 'Added to your travel kit.';
        toast.classList.add('is-visible');
        window.setTimeout(function () {
          toast.classList.remove('is-visible');
        }, 2200);
      }
    });
  }

  function initCartPage(root) {
    var list = root.querySelector('[data-rv-pet-cart-list]');
    var empty = root.querySelector('[data-rv-pet-cart-empty]');
    var totalElement = root.querySelector('[data-rv-pet-cart-total]');
    var summary = root.querySelector('[data-rv-pet-cart-summary]');
    if (!list) return;

    function render() {
      var items = readCart();
      list.innerHTML = '';
      if (!items.length) {
        if (empty) empty.hidden = false;
        if (summary) summary.hidden = true;
        return;
      }
      if (empty) empty.hidden = true;
      if (summary) summary.hidden = false;
      items.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'rv-pet__cart-row';
        row.innerHTML =
          '<div class="rv-pet__cart-thumb" aria-hidden="true"></div>' +
          '<div class="rv-pet__cart-info">' +
            '<strong></strong>' +
            '<small></small>' +
            '<div class="rv-pet__qty" style="margin-top:12px">' +
              '<button type="button" data-dec aria-label="Decrease quantity">−</button>' +
              '<input type="text" inputmode="numeric" value="" data-qty aria-label="Quantity">' +
              '<button type="button" data-inc aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" data-remove class="rv-pet__text-link" style="margin-top:12px;border:0;background:none;padding:0;cursor:pointer">Remove</button>' +
          '</div>' +
          '<em></em>';
        row.querySelector('strong').textContent = item.title;
        row.querySelector('small').textContent = money(item.price);
        row.querySelector('em').textContent = money(item.price * item.qty);
        var quantityField = row.querySelector('[data-qty]');
        quantityField.value = String(item.qty);
        row.querySelector('[data-dec]').addEventListener('click', function () {
          setQty(item.handle, Math.max(0, item.qty - 1));
        });
        row.querySelector('[data-inc]').addEventListener('click', function () {
          setQty(item.handle, item.qty + 1);
        });
        quantityField.addEventListener('change', function () {
          setQty(item.handle, quantityField.value);
        });
        row.querySelector('[data-remove]').addEventListener('click', function () {
          removeItem(item.handle);
        });
        list.appendChild(row);
      });
      if (totalElement) totalElement.textContent = money(cartTotal(items));
    }

    document.addEventListener('rv-pet-cart-updated', render);
    render();
  }

  function boot() {
    var hasLiveStore = Boolean(document.querySelector('[data-rv-pet-live]'));
    document.querySelectorAll('[data-rv-pet]').forEach(function (root) {
      initChrome(root);
      initMotion(root);
      initFilters(root);
      initLocalSort(root);
      initQuantityControls(root);
      initLiveAddToCartMotion(root);
      if (!hasLiveStore) {
        initAddToCart(root);
        initCartPage(root);
      }
    });
    if (!hasLiveStore) syncCartCount();
  }

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-rv-pet-atc-motion]').forEach(resetAddToCartMotion);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.RavzeloPetProto = {
    readCart: readCart,
    addToCart: addToCart,
    cartCount: cartCount
  };
})();
